/**
 * @file Location policy handling for the registration page.
 */

import {getIconHtmlForServerIcon} from '../common/icon.js';
import {ICON} from '../common/icons.js';

/**
 * Initializes the location policy UI for the registration page.
 * @public
 */
export function initialize() {
    var policyIcon = $('.reg-location-policy-icon');
    if (!$('.regCompany').is('[data-location-policy-applicable]')) {
        return;
    }
    policyIcon.html(getIconHtmlForServerIcon(ICON.INFO));
    policyIcon.tooltip({container: 'body'});
    applyLocationPolicyForSelectedCompany();
    $('.regCompany').on('change', applyLocationPolicyForSelectedCompany);
}

/**
 * Returns the location value to submit based on the active location policy.
 * @returns {boolean} The location value to submit.
 * @public
 */
export function getLocationValue() {
    var activePolicy = $('.regCompany').data('active-location-policy');
    if (activePolicy === 'enabled') {
        return true;
    }
    if (activePolicy === 'disabled') {
        return false;
    }
    return $('.regLocation').is(':checked');
}

// Updates the location checkbox and policy icon to reflect the selected company's location policy.
function applyLocationPolicyForSelectedCompany() {
    var policy = $('.regCompany option:selected').data('location-policy'),
        isPolicySet = policy === 'enabled' || policy === 'disabled',
        locationCheckbox = $('.regLocation'),
        policyIcon = $('.reg-location-policy-icon');

    $('.regCompany').data('active-location-policy', isPolicySet ? policy : null);
    locationCheckbox.prop('disabled', isPolicySet);
    if (isPolicySet) {
        locationCheckbox.prop('checked', policy === 'enabled');
    }
    policyIcon.toggle(isPolicySet);
}
